<!-- 考题添加弹框 -->
<template>
    <el-dialog :title="$t('paper.chooseTopic')"
               width="72%"
               top="50px"
               custom-class="topic-dialog"
               :visible="value"
               :close-on-click-modal="false"
               :append-to-body="false"
               :modal-append-to-body="false"
               @close="close"
    >
        <el-tabs v-model="tab" type="card">
            <el-tab-pane label="我的考题" name="1"></el-tab-pane>
            <el-tab-pane label="考题库" name="2"></el-tab-pane>
            <el-tab-pane label="题组" name="3"></el-tab-pane>
        </el-tabs>

        <div class="dialog-main">

            <div class="left-wrap" >
                <div class="left-wrap-title">{{tab == '3' ? '题组列表': '查询条件'}}</div>

                <div class="left-wrap-content">

                    <el-form
                        v-if="tab != '3'"
                        class="dialog-form"
                        :model="formSearch"
                        label-position="top"
                        size="mini">
                        <el-form-item :label="$t('c.problemNo')">
                            <el-input v-model="formSearch.number" :placeholder="$t('tip.problemNo')"
                                      @keyup.enter.native="getTable(1)" clearable></el-input>
                        </el-form-item>

                        <!-- 题目描述 -->
                        <el-form-item v-if="isTheory" :label="$t('topic.questionDesc')">
                            <el-input v-model="formSearch.title" :placeholder="$t('tip.titleDesc')"
                                      @keyup.enter.native="getTable(1)" clearable></el-input>
                        </el-form-item>

                        <select-multiple ref="selectMultiple"
                                         :nameArrays="selectNames"
                                         @getForLevelVal="getForLevelVal"
                                         @getDifficultyVal="getDifficultyVal"
                                         @getTopicTypeVal="getTopicTypeVal">
                        </select-multiple>
                        <select-multi-knowledge
                            ref="selectMultiKnowledge"
                            :type="isTheory ? 'Theory': 'Image'"
                            @knowledgeChange="knowledgeChange">
                        </select-multi-knowledge>
                        <el-form-item>
                            <el-button class="btn-query" @click="getTable(1)" icon="el-icon-search" size="small">{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>

                    <div class="topic-set" v-else>
                        <div class="topic-set-search">
                            <el-input v-model="topicSetInput" :placeholder="$t('tip.name')"
                                      @keyup.enter.native="getTopicSetList" size="mini" clearable>
                                <el-button slot="append" @click="getTopicSetList" icon="el-icon-search"></el-button>
                            </el-input>
                        </div>

                        <ul class="topic-set-list" v-if="topicSetList.length">
                            <li class="topic-set-item"
                                :class="{'active': topicSetActive === item.id}"
                                v-for="item in topicSetList"
                                :key="item.id"
                                :title="item.name"
                                @click="chooseTopicSet(item.id)"
                            >{{item.name}}</li>
                        </ul>

                        <div class="no-data" v-else>暂无题组</div>
                    </div>
                </div>

            </div>

            <data-tables-server
                class="dialog-table"
                ref="topicTable"
                :data="dialogTableData"
                :total="page.total"
                :table-props="tableProps"
                :current-page.sync="page.current"
                :page-size="page.size"
                :pagination-props="paginationProps"
                :key="tab"
                @query-change="onPage"
                @selection-change="handleSelectionChange"
                v-viewer
            >
                <!-- column checkbox -->
                <el-table-column
                    type="selection"
                    width="55px"
                    :reserve-selection="true"
                    :selectable="isCheckboxSelectable"
                    align="center">
                </el-table-column>

                <!-- column expand -->
                <el-table-column v-if="isTheory" type="expand" width="48px">
                    <template #default="{row}">
                        <div class="topic-expand">
                            <div class="left-content">
                                <div class="topic-item">
                                    <div class="item-title">题干</div>
                                    <div class="item-detail">
                                        <h3 class="title" v-html="row.titleRT"></h3>
                                        <div class="option"
                                             v-for="(item, i) in row.options"
                                        >
                                            <div v-html="String.fromCharCode(65+i)+'. &nbsp;'"></div>
                                            <div v-html="item.titleRT || item.tagName"></div>
                                        </div>
                                        <img v-if="row.type === 4" :src="row.picViewUrl" alt="match image">
                                    </div>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="topic-item">
                                    <div class="item-title">答案</div>
                                    <div class="item-detail">{{row.keyName}}</div>
                                </div>
                                <div class="topic-item">
                                    <div class="item-title">解析</div>
                                    <div class="item-detail" v-html="row.analysisRT || '无'"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column property="number" :label="$t('c.problemNo')" align="center" width="100px"></el-table-column>

                <el-table-column v-if="isTheory" prop="type" :label="$t('paper.questionType')" width="105px" align="center">
                    <template #default="{row}">
                        <type-tag
                            type="topicType"
                            :id="row.type"
                            :name="row.typeName"
                        ></type-tag>
                    </template>
                </el-table-column>

                <!-- 题目描述 -->
                <!-- 理论 -->
                <el-table-column v-if="isTheory" :label="$t('topic.questionDesc')" min-width="300px" show-overflow-tooltip>
                    <template #default="{row}">
                        <div class="topic-desc">
                            <!-- 1单选、2多选、3判断 -->
                            <div v-if="[1,2,3].includes(row.type)" class="topic-theory">
                                <p class="topic-title" v-html="row.titleRT"></p>
                            </div>

                            <!-- 4配对题 -->
                            <div v-if="row.type === 4" class="topic-match">
                                <p class="topic-title" v-html="row.titleRT"></p>
                                <img class="match-image" :src="row.picViewUrl" alt="match image">
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <!-- 图像 -->
                <el-table-column v-else :label="$t('c.image')" min-width="300px" align="center">
                    <template #default="{row}">
                        <div class="topic-desc">
                            <!-- 5DR、6CT -->
                            <div v-if="[5,6].includes(row.type)" class="topic-image">
                                <img v-if="row.luggage" :src="row.luggage ? row.luggage.thumbnails[0].url:''" alt="image" />
                                <img v-else-if="row.thumbnails" :src="row.thumbnails[0].url" alt="image" />
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column property="knowledgeName" :label="$t('c.knowledgePoint')" align="center"
                                 width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column property="forLevelName" :label="$t('c.operatorLevel')" align="center"
                                 width="100px" show-overflow-tooltip></el-table-column>
                <el-table-column property="difficultyName" :label="$t('c.difficulty')" align="center"
                                 width="100px" show-overflow-tooltip></el-table-column>
                <el-table-column  v-if="!isShowAccuracy" :label="$t('topic.rightRate')" align="center" property="accuracy"
                                 width="100px" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{scope.row.accuracy !== null ? (Math.round(scope.row.accuracy * 10000) / 100 + '%') : '--'}}</span>
                    </template>
                </el-table-column>
            </data-tables-server>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close" size="medium">{{$t('c.cancel')}}</el-button>
            <el-button @click="dialogSave" type="primary" size="medium">
                {{$t('c.save')}}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>

/**
 * todo: 重置表格的折叠/展开状态
 */
export default {
    components: {
    },

    props: {
        // 打开/关闭弹框，直接用v-model即可
        value: {
            type: Boolean,
            default: false,
        },

        // 考卷类型 1理论、3CT、4DR
        paperType: {
            type: Number,
            default: 1,
        },

        // 打开dialog前就已选择的数据
        initIds: Array,

        // 打开dialog后，是否将已选择行的checkbox禁用
        disableChecked: {
            type: Boolean,
            default: false,
        },

        // 禁用的题组id，此题组不会出现在题组列表中
        disabledTopicSetId: {
            type: String
        },
        isShowAccuracy:{
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            tab: '1',
            resetMulti: false,
            formSearch: {
                number: '',
                title: '',
                forLevels: [],
                difficulties: [],
                types: [],
                knowledges: [0],
            },
            selectNames: [
                {
                    key: "forLevel",
                }, {
                    key: "difficulty",
                }, {
                    key: "topicType",
                    onlyTheory: true
                }],
            tableProps: {
                border: true,
                stripe: false,
                rowKey: row => row.id,
                height: "60vh"
            },
            paginationProps: {
                pageSizes: [50, 100, 300, 500],
            },
            page: {
                current: 1,
                size: 50,
                total: 0,
                sortName: '',
                order: '',
            },

            topicSetList: [],
            topicSetActive: '',
            topicSetInput: '',

            dialogTableData: [],
            selectIds: [],
            selectData: []
        }
    },

    computed: {
        isTheory() {
            if (this.paperType !== 1) {
                let idx = this.selectNames.findIndex(item => item.key === 'topicType')
                if (idx > -1) this.selectNames.splice(idx, 1)
            }

            return this.paperType === 1
        }
    },

    watch: {
        tab(v) {
            this.page.sortName = ''
            this.page.order = ''

            this.initDialog()
        },

        topicSetActive(id) {
            if (this.value) {
                this.getTopicSetTable()
            }
        },

        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            }
        },
    },

    mounted() {
        this.getTopicSetList().then(data => {
            this.topicSetActive = data[0] && data[0].id
        })
    },

    methods: {
        async initDialog() {
            await this.resetDialog()

            this.getTable(1)
        },

        getTopicSetList() {
            return this.$api.getTopicSetList({
                name: this.topicSetInput,
                type: 2,
                topicType: this.paperType
            }).then(res => {
                let data = res.package.filter(item => item.id !== this.disabledTopicSetId)

                this.topicSetList = data
                return data
            })
        },

        getTable(page) {
            if(page) this.page.current = page;

            if (this.tab == '3') {
                this.getTopicSetTable()
            } else {
                this.getTopicTable()
            }
        },

        getTopicTable() {
            let queryData = {
                ...this.formSearch,
                PageNO: this.page.current,
                Limit: this.page.size,
                sortName: this.page.sortName,
                order: this.page.order,
                isOnlyMine: this.tab == '1'
            };

            // 全选不传值
            ['forLevels', 'difficulties', 'types', 'knowledges'].forEach(v => {
                if (this.formSearch[v].includes(0)) {
                    delete queryData[v]
                }
            })

            let getTopic = {
                1: this.$api.getTheoryTopic,
                3: this.$api.getCTTopicList,
                4: this.$api.getDRTopicList,
            }[this.paperType]

            getTopic(queryData).then(res => {
                this.dialogTableData = res.package
                this.page.total = res.total

                let elTable = this.$refs.topicTable.$refs.elTable

                this.dialogTableData.forEach(row => {
                    if (this.initIds.includes(row.id)) {
                        elTable.toggleRowSelection(row, true)
                    }
                })
            })
        },

        getTopicSetTable() {
            if (!this.topicSetActive) {
                this.dialogTableData = []
                this.page.total = 0
                return
            }

            let queryData = {
                PageNO: this.page.current,
                Limit: this.page.size,
                sortName: this.page.sortName,
                order: this.page.order,
            };

            this.$api.getTopicSetDetail(this.topicSetActive, queryData).then(res => {
                let data = res.package
                this.dialogTableData = data.topics
                this.page.total = data.size

                let elTable = this.$refs.topicTable.$refs.elTable

                this.dialogTableData.forEach(row => {
                    if (this.initIds.includes(row.id)) {
                        elTable.toggleRowSelection(row, true)
                    }
                })
            })
        },

        onPage(q) {
            if (q.type === 'init') return
            this.page.current = q.page
            this.page.size = q.pageSize
            let order = q.sort.order

            if (order) {
                this.page.sortName =  q.sort.prop
                this.page.order = {
                    'ascending': 'Asc',
                    'descending': 'Desc'
                }[order]
            } else {
                this.page.sortName = ''
                this.page.order = ''
            }

            this.getTable()
        },

        chooseTopicSet(id) {
            this.topicSetActive = id
        },

        handleSelectionChange(arr) {
            // 这里由于后端分页，切换页码时调用的toggleRowSelection也会触发selecitonChange，导致数据重复
            // 需要过滤掉重复的数据
            let row = []

            arr.forEach(item => {
                if (!row.find(v => v.id === item.id)) {
                    row.push(item)
                }
            })

            this.selectIds = row.map(item => item.id)
            this.selectData = row
        },
        dialogSave() {
            this.$emit('on-save', this.selectIds, this.selectData)
            this.close()
        },

        resetDialog() {
            return new Promise(resolve => {
                // 重置表格和表单
                this.$nextTick(() => {
                    let elTable = this.$refs.topicTable.$refs.elTable
                    elTable.clearSelection()
                    //elTable.clearSort()
                    elTable.doLayout()

                    // 初始化查询条件
                    this.formSearch = {
                        number: '',
                        title: '',
                        forLevels: [],
                        difficulties: [],
                        types: [],
                        knowledges: [0],
                    }

                    // 重置多选下拉框组件
                    this.$refs.selectMultiple && this.$refs.selectMultiple.reset()
                    this.$refs.selectMultiKnowledge && this.$refs.selectMultiKnowledge.reset()

                    // 清理题组
                    if (this.tab == '3') {
                        this.topicSetInput = ''
                        this.getTopicSetList().then(data => {
                            this.topicSetActive = data[0] && data[0].id
                        })
                    }

                    resolve()
                })
            })
        },

        isCheckboxSelectable(row) {
            if (!this.disableChecked) {
                return true
            } else {
                return !this.initIds.includes(row.id)
            }
        },

        getForLevelVal(data) {
            this.formSearch.forLevels = data
        },
        getTopicTypeVal(data) {
            this.formSearch.types = data
        },
        getDifficultyVal(data) {
            this.formSearch.difficulties = data
        },
        knowledgeChange(data) {
            this.formSearch.knowledges = data
        },

        close() {
            let topicTable = this.$refs.topicTable.$refs.elTable;
            topicTable.clearSelection();
            this.$emit('input', false)
        }
    },
}
</script>

<style lang="scss">
$side-width: 240px;

.topic-dialog {
    min-width: 1180px;

    .el-dialog__header {
        border: none;
    }

    .el-dialog__body {
        padding-top: 0;
    }

    .dialog-main {
        display: flex;
        overflow: hidden;
    }

    .left-wrap {
        width: $side-width;
        flex-shrink: 0;
        margin-bottom: 0;
        padding-left: 0;
        padding-right: 30px;
        height: 60vh;
        min-height: 480px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .left-wrap-title {
            height: 46px;
            line-height: 46px;
            padding: 0 20px;
            font-weight: 600;
            background-color: #f4f3f8;
            border: 1px solid #EBEEF5;
        }

        .left-wrap-content {
            position: relative;
            flex: 1;
            overflow: auto;
            border: 1px solid #EBEEF5;
            border-top: none;
        }
    }

    .dialog-form {
        padding: 12px 16px;
        .el-form-item__label {
            padding: 0;
        }

        .el-form-item {
            margin-bottom: 12px;
        }

        .btn-query {
            display: block;
            margin-top: 10px;
            width: 60%;
        }
    }

    .topic-set {

        .topic-set-search {
            padding: 12px 12px;
        }

        .topic-set-item {
            padding: 10px 12px;
            cursor: pointer;
            @include no-wrap;

            &.active {
                background-color: #caedff;
            }
        }

        .no-data {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%);
            margin-top: -18px;
            color: #909399;
        }
    }

    .dialog-table {
        //flex: 1;
        width: calc(100% - #{$side-width} - 10px);

        thead > tr > th {
            color: #252525;
            background-color: #f4f3f8;
        }
        td {
            padding: 12px 0;
        }
        .cell {
            padding: 0 10px;
        }
        .el-table {
            min-height: 480px;
        }

        .el-pagination {
            text-align: left;
        }
    }

    .el-dialog__footer {
        padding: 0;
        border-top: 1px solid #eee;

        .dialog-footer {
            padding: 10px 20px;
        }

        button {
            min-width: 110px;
            margin-left: 16px;
        }
    }

    .topic-expand {
        display: flex;
        padding: 0 20px 0 105px;
        .left-content {
            flex: 1;
        }
        .right-content {
            flex: 1;
            .topic-item {
                padding-left: 10%;
                margin-bottom: 10px;
            }
        }
        .topic-item {
            display: flex;
            line-height: 1.5;
        }
        .item-title {
            width: 40px;
            margin-right: 10px;
            flex-shrink: 0;
            color: #b4b6bd;
        }
        .item-detail {
            .title {
                margin-bottom: 10px;
            }
            .option {
                margin-bottom: 8px;
                > div {
                    display: inline-block;
                }
            }
            img {
                max-height: 300px;
            }
        }
    }

    .topic-desc {
        .topic-theory {
            img {
                margin-top: 0;
                height: 70px;
                width: auto;
                cursor: pointer;
            }
        }

        .topic-match {
            .match-image {
                height: 70px;
                width: auto;
                cursor: pointer;
            }
        }

        .topic-image {
            img {
                height: 100px;
                width: auto;
                cursor: pointer;
            }
        }
    }

    .topic-title {
        @include no-wrap;

        p {
            @include no-wrap;
        }
    }
}
</style>
